'use strict';

namespace Core {

    class LoaderPanel {

        private busy: boolean;

    }

    angular
        .module('core')
        .directive('loaderPanel', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                bindToController: {
                    busy: '='
                },
                controller: LoaderPanel,
                controllerAs: 'lp',
                template: '<div ng-show="lp.busy" class="loader-panel">' +
                            '<preloader class="circular subtle large"></preloader>' +
                          '</div>'
            };
        });

}
